import { render, staticRenderFns } from "./PatientSuggestionFilter.vue?vue&type=template&id=a1b9bd38&"
import script from "./PatientSuggestionFilter.vue?vue&type=script&lang=js&"
export * from "./PatientSuggestionFilter.vue?vue&type=script&lang=js&"
import style0 from "./PatientSuggestionFilter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports